import { ErrorData } from '@membranehq/sdk'
import { toHeaderCase } from 'js-convert-case'

import { ErrorItem } from './ErrorItem'
import { getErrorAdditionalData, hasErrorAdditionalData } from './helpers'

export function ErrorBadge({ error }: { error: ErrorData }) {
  if (!(error.type || error.key)) return null

  const badges = [error.type, error.key].filter(Boolean).map(toHeaderCase)

  return (
    <div className='flex items-center -ms-1'>
      {badges.map((badge) => (
        <ErrorItem.Badge key={badge}>{badge}</ErrorItem.Badge>
      ))}
    </div>
  )
}

export function ErrorJSON({ error }: { error: ErrorData }) {
  if (!hasErrorAdditionalData(error)) return null

  return <ErrorItem.JSONViewer json={getErrorAdditionalData(error)} />
}
